module.exports = __webpack_public_path__ + "media/images/design/common/images/h1_header-6b8c1fd1c618d6c97e4e9948f443273f.jpg";